module.exports = __webpack_public_path__ + "static/img/SCQR.a02a3c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/SCQR.png
// module id = P+Kc
// module chunks = 19